const footerColumns = [
  {
    title: '浏览',
    links: [
      { label: '实时快讯流', href: '#flash' },
      { label: '热瓜合集索引', href: '#collections' },
      { label: '讨论区精选', href: '#topics' },
      { label: '瓜友群分区', href: '#community' },
    ],
  },
  {
    title: '热门合集',
    links: [
      { label: '年度大瓜年鉴', href: '#collections' },
      { label: '番位争议全记录', href: '#collections' },
      { label: '红毯造型红黑榜', href: '#collections' },
      { label: '瓜友考古档案', href: '#collections' },
    ],
  },
  {
    title: '参与',
    links: [
      { label: '我要爆料', href: '#community' },
      { label: '发起新话题', href: '#topics' },
      { label: '新人入坑指引', href: '#community' },
      { label: '社区约定', href: '#topics' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-fire-fill text-xl" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black text-background-50">黑料吃瓜</span>
                <span className="mt-1 font-label text-[9px] tracking-[0.3em] text-background-400">GOSSIP&nbsp;WEEKLY</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-300">
              汇聚全网瓜友的在线讨论社区。以实时爆料为主线，用合集索引做归档，让每一次围观都有据可查。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {['讨论区', '瓜友群', '实时爆料', '合集索引'].map((tag) => (
                <span key={tag} className="rounded-full border border-background-50/15 px-3 py-1 font-label text-[11px] text-background-300">
                  #{tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h3 className="font-heading text-sm font-bold tracking-wide text-accent-400">{col.title}</h3>
              <ul className="mt-5 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="cursor-pointer text-sm text-background-300 transition-colors hover:text-background-50">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h3 className="font-heading text-sm font-bold tracking-wide text-accent-400">本期</h3>
            <div className="mt-5 font-heading text-3xl font-black text-background-50">128</div>
            <p className="mt-1 font-label text-[11px] tracking-widest text-background-400">VOL · 2026.10.10</p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-background-400">
            © 2026 黑料吃瓜 · 页面内容为演示用途，情节与人物均为虚构，请勿对号入座。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-pulseDot" />
              社区在线
            </span>
            <a href="#top" className="hidden cursor-pointer whitespace-nowrap transition-colors hover:text-background-50 sm:inline">
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}